/* eslint-disable import/prefer-default-export */
import Vue from 'vue'
import $ from 'jquery'

export const fullScreenImageModal = new Vue({
	methods: {
		modalOpen (screenWidth, from, index) {
			if (screenWidth < 992) {
				const id1 = `lightBoxMob${from}${index}`
				document.getElementById(id1).classList.add('open')
			} else {
				const id = `#lightBoxWeb${from}${index}`
				$(id).modal('show')
			}
		},
		closeModal (e, from, index) {
			e.preventDefault()
			const id = `lightBoxMob${from}${index}`
			if (document.getElementById(id) && document.getElementById(id).classList) {
				document.getElementById(id).classList.remove('open')
			}
		}
	}
})
